var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCitimSaZle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "#FAF3F3",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 17.4926C40.5 23.5405 34.1331 28.6428 26 28.6428C17.8669 28.6428 11.5 23.5405 11.5 17.4926C11.5 15.9739 11.8939 14.965 12.5439 14.2703C13.2034 13.5654 14.1869 13.1184 15.4935 12.8513C16.7998 12.5842 18.3747 12.5075 20.1633 12.5005C21.055 12.4971 21.9922 12.5108 22.9694 12.5255L23.035 12.5265C23.9906 12.5409 24.9833 12.5559 26 12.5559C27.0167 12.5559 28.0094 12.5409 28.965 12.5265L29.0306 12.5255C30.0078 12.5108 30.945 12.4971 31.8367 12.5005C33.6253 12.5075 35.2002 12.5842 36.5065 12.8513C37.8131 13.1184 38.7966 13.5654 39.4561 14.2703C40.1061 14.965 40.5 15.9739 40.5 17.4926Z",
    fill: "#1572A1",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9286 35.5714C31.9286 38.8457 29.2743 41.5 26 41.5C22.7258 41.5 20.0714 38.8457 20.0714 35.5714C20.0714 32.2972 22.7258 29.6429 26 29.6429C29.2743 29.6429 31.9286 32.2972 31.9286 35.5714Z",
    fill: "#1572A1",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitimSaZle);
export default __webpack_public_path__ + "static/media/CitimSaZle.457368558b6dc22979a38f6b832f0b8a.svg";
export { ForwardRef as ReactComponent };